import React from "react";
import BoardMembers from "../components/BoardMembers";
import TextAnimation from "../components/scroll-text";
import AboutSchool from "../components/AboutSchool";
import SEOHead from "../components/SEOHead";

const AboutUs = () => {

	const proprietorName = "Vil Tsukru";

	return (
		<section className=" bg-blue-theme py-12 px-2 md:px-4">
			<SEOHead
				title="About Sacred Heart School - Our Story, Mission & Team"
				description="Want to know more about us? Sacred Heart School in Chumoukedima has been nurturing young minds with dedicated teachers and a caring environment. Meet our team and learn about our mission."
				keywords="about sacred heart school, school mission and vision, our teachers, school management chumoukedima, proprietor message, why choose our school"
				canonicalUrl="https://sacredheartchumoukedima.com/about"
				ogTitle="Get to Know Sacred Heart School - Our Mission & Values"
				ogDescription="A school where every child is valued. Learn about our mission, meet our dedicated team, and discover what makes us special."
			/>
			<div className="container mx-auto px-2 md:px-4">
				{/* Proprietor's Section */}
				<div className="flex flex-col bg-white rounded shadow-lg py-12 md:flex-row items-center gap-8 mb-12">
					<img
						src="/assets/images/faculties/Vil Tsukru.jpg"
						alt="Proprietor"
						className="w-64 aspect-square rounded-full md:mx-8 shadow-lg object-cover"
					/>
					<div className="mx-4 md:mx-8 text-justify">
						<h3 className="text-2xl font-bold text-theme mb-4">
							<TextAnimation text="Message from the Proprietor" />
						</h3>
						<p className="text-gray-700 font-bold my-2 leading-relaxed">
							Dear Parents, Students, and Esteemed Visitors,
						</p>
						<p className="text-gray-700 my-2 leading-relaxed">
							A heartfelt welcome to Sacred Heart School, Chümoukedima, a sanctuary of learning and growth. On behalf of the Management, our dedicated faculty and staff, I extend warm greetings to you.
						</p>
						<p className="text-gray-700 my-2 leading-relaxed">
							Sacred Heart School is more than an institution; it's a family that cherishes diversity, promotes collaboration, and instills a sense of responsibility in each student. As you navigate our website, we invite you to explore the world of opportunities and experiences that await your child.
						</p>
						<p className="text-gray-700 my-2 leading-relaxed">
							The entire Sacred Heart School family looks forward to a collaborative partnership with you. Should you have any inquiries or require assistance, feel free to reach out.
						</p>
						<p className="text-gray-700 my-2 leading-relaxed">
							Thank you for choosing Sacred Heart School. Here's to a meaningful and enriching educational journey for your child.
						</p>
						<p className="mt-4 font-bold text-gray-700 italic">
							<TextAnimation text={`- ${proprietorName}`} />
						</p>
						<div className="mt-4 font-bold text-gray-700 italic">
							<p>Email: viltsukru8@gmail.com</p>
							<p>Contact: +91 84148 91204</p>
						</div>
					</div>
				</div>
				<AboutSchool />
				<BoardMembers />
				{/* <div className="flex flex-col bg-white rounded shadow-lg py-12 md:flex-row items-center gap-8 mb-12">
					<div className="mx-8 text-justify">
						<h3 className="text-2xl font-bold text-theme mb-4">
							<TextAnimation text="History of the School" />
						</h3>
						<p className="text-gray-700 leading-relaxed">
							<TextAnimation text={historyOfTheSchool} />
						</p>
					</div>
				</div> */}
			</div>
		</section>
	);
};

export default AboutUs;
